import CategoriesList from 'components/admin/Categories/CategoriesList'
import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { initialize } from 'redux-form'
import { Grid, Segment } from 'semantic-ui-react'

const i18nkey = 'admin.product.categories.'

const mapStateToProps = (state, ownProps) => {
  const { categories, categoriesLoading } = state.categories
  return { categories, categoriesLoading }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ initialize }, dispatch)
}

class CategoriesBrowser extends React.Component {
  state = {
    dragMarker: {},
  }

  actions(parent_id) {
    const {
      initialize,
      categoriesLoading, // connecy
    } = this.props

    return [
      {
        icon: 'add',
        color: 'blue',
        disabled: categoriesLoading,
        content: I18n.t(i18nkey + 'new_product_category'),
        onClick: () => {
          initialize('add_category_modal', {
            type: 'standard',
            title_de: '',
            title_fr: '',
            parent_id: parent_id,
            link_target_id: -1,
          })
        },
      },
    ]
  }

  render() {
    const dark = config.theme.dark
    const { dragMarker = {} } = this.state
    const {
      categoriesLoading,
      categories = [], //connect
      match: {
        params: { id },
      }, //withRouter
    } = this.props
    const selectedCategory = categories.find(
      (category) => category.id !== 1 && category.id === Number(id)
    )
    const parentCategory =
      selectedCategory &&
      categories.find(
        (category) =>
          category.id !== 1 && category.id === selectedCategory.parent_id
      )
    const grandParentCategory =
      parentCategory &&
      categories.find(
        (category) =>
          category.id !== 1 && category.id === parentCategory.parent_id
      )

    const category1 =
      grandParentCategory || parentCategory || selectedCategory || {}
    const category2 =
      (grandParentCategory && parentCategory) ||
      (parentCategory && selectedCategory) ||
      {}
    const category3 = (grandParentCategory && selectedCategory) || {}

    const list1 = categories
      .filter((category) => category.parent_id === 1)
      .sort((a, b) => a.row_order - b.row_order)
    const list2 = categories
      .filter((category) => category.parent_id === category1.id)
      .sort((a, b) => a.row_order - b.row_order)
    const list3 = categories
      .filter((category) => category.parent_id === category2.id)
      .sort((a, b) => a.row_order - b.row_order)

    const list1Props = {
      categories: list1,
      selectedId: category1.id,
      dragMarker,
      dndName: 'CategoriesList1',
      findCategory: (id) => categories.find((category) => category.id === id),
      setDragMarker: (dragMarker) => this.setState({ dragMarker }),
    }
    const list2Props = {
      categories: list2,
      selectedId: category2.id,
      dragMarker,
      dndName: 'CategoriesList2',
      findCategory: (id) => categories.find((category) => category.id === id),
      setDragMarker: (dragMarker) => this.setState({ dragMarker }),
    }
    const list3Props = {
      categories: list3,
      selectedId: category3.id,
      dragMarker,
      dndName: 'CategoriesList3',
      findCategory: (id) => categories.find((category) => category.id === id),
      setDragMarker: (dragMarker) => this.setState({ dragMarker }),
    }

    return (
      <div
        className={classNames([
          'categoriesBrowser',
          'ui',
          'form',
          dark && 'inverted',
        ])}>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={12}>
              <ComponentHeader
                loading={categoriesLoading}
                title="Level 1"
                actions={this.actions(1)}
              />
              <Segment
                attached
                loading={categoriesLoading}
                className={classNames([
                  'payload small',
                  dark && 'inverted',
                  categoriesLoading && 'spaced',
                ])}>
                <CategoriesList {...list1Props} />
              </Segment>

              {list2.length > 0 && (
                <div>
                  <ComponentHeader
                    loading={categoriesLoading}
                    title="Level 2"
                    actions={this.actions(category1.id)}
                  />
                  <Segment
                    attached
                    loading={categoriesLoading}
                    className={classNames([
                      'payload small',
                      dark && 'inverted',
                      categoriesLoading && 'spaced',
                    ])}>
                    <CategoriesList {...list2Props} />
                  </Segment>
                </div>
              )}

              {list3.length > 0 && (
                <div>
                  <ComponentHeader
                    loading={categoriesLoading}
                    title="Level 3"
                    actions={this.actions(category2.id)}
                  />
                  <Segment
                    attached
                    loading={categoriesLoading}
                    className={classNames([
                      'payload small',
                      dark && 'inverted',
                      categoriesLoading && 'spaced',
                    ])}>
                    <CategoriesList {...list3Props} />
                  </Segment>
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

CategoriesBrowser = connect(mapStateToProps, mapDispatchToProps)(
  CategoriesBrowser
)
export default withRouter(CategoriesBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoriesBrowser.jsx